module.exports = __webpack_public_path__ + "img/swipe1-icon.7f29805d.png";